export class LogFileCnvrtCSV {
    
      
      LOG_DATE: string;
        
  }